<template>
  <div>
    <status-bar :status="status + ''"></status-bar>
    <div class="row-bg">
      <div class="row row1">
        <p class="r-province" :class="workProvince == '工作地-省份' ? '' : 'txt-color'" @click="provincePickerClick">{{
      workProvince }}
        </p>
        <p class="r-city" :class="workCity == '工作地-城市' ? '' : 'txt-color'" @click="cityPickerClick">{{ workCity }}</p>
      </div>
      <div class="row" v-if="isShowWorkType">
        <p :class="workType == '选择加盟司机类型' ? '' : 'txt-color'" @click="typePickerClick">{{ workType }}</p>
      </div>
      <div class="row">
        <p :class="msgFrom.value == '招募信息来源' ? '' : 'txt-color'" @click="fromPickerClick">{{ msgFrom.value }}</p>
      </div>
      <div v-if="msgFrom.value == '司机推荐' && workType != '轻享司机'" class="row">
        <input type="text" maxlength="10" placeholder="请输入邀请码（如有）" v-model="inviteCode" @blur="inputBlurEvent">
      </div>
      <div class="row">
        <input type="tel" maxlength="11" placeholder="紧急联系人手机" v-model="contactPhone" @blur="inputBlurEvent">
      </div>
    </div>
    <p class="next-btn" :class="complete" @click="showConfirmBox">下一步</p>
    <p class="detail">找不到的某个城市表示该城市暂未开通代驾服务</p>
    <div class="introduce-container" v-if="workTypeId == 4">
      <div class="introduce-title"><span class="text">什么是轻享司机？</span><span class="bgc"></span></div>
      <p class="introduce-desc">
        为了让更多的司机师傅们通过闲散时间通过开车获得收益，e代驾推出时间更灵活、入职门槛更低、规则更宽松的轻享司机，该类司机认证后可在平台接听特惠代驾和三方订单，每天听一单也是一笔不小的收益积累，欢迎各位师傅加盟。
      </p>
    </div>
    <div class="introduce-container" v-if="workTypeId == 1">
      <div class="introduce-title"><span class="text">什么是精选司机？</span><span class="bgc"></span></div>
      <p class="introduce-desc">
        e代驾合规认证司机升级成为精选司机，通过平台的体系化培训和服务标准管控为客户带来品质化的代驾体验，可享受接听e代驾全渠道订单的资格，可认证升级成为车后司机。享有更多的收入保障，欢迎各位师傅加盟。
      </p>
    </div>
    <div class="tips">
      {{ defaultInfo.default_text }}<span>{{ defaultInfo.default }}</span>
    </div>
    <div class="confirm" :class="showConfirm ? 'show' : 'hide'">
      <div class="c-bg">
        <div class="c-title">
          <p>请确认所录入信息正确</p>
        </div>
        <div class="c-content">
          <p>工作地：{{ workProvince + " " + workCity }}</p>
          <p>招募信息来源：{{ msgFrom.value }}</p>
          <p>紧急联系人手机：{{ contactPhone }}</p>
        </div>
        <div class="c-bottom">
          <p class="c-cancel" @click="cancelBtnAction">返回修改</p>
          <p class="c-sure" @click="sureBtnAction">确认提交</p>
        </div>
      </div>
    </div>
    <awesome-picker ref="picker1" :data="picker.data1" :textTitle="picker.textTitle1" :textConfirm="picker.textConfirm"
      :textCancel="picker.textCancel" @cancel="handlePickerCancel" @confirm="handlePickerConfirm1"></awesome-picker>
    <awesome-picker v-for="item in options" :key="item.num" ref="picker2" :data="picker.data2"
      :textTitle="picker.textTitle2" :textConfirm="picker.textConfirm" :textCancel="picker.textCancel"
      @cancel="handlePickerCancel" @confirm="handlePickerConfirm2">{{ item.num }}</awesome-picker>
    <awesome-picker ref="picker3" :data="picker.data3" :textTitle="picker.textTitle3" :textConfirm="picker.textConfirm"
      :textCancel="picker.textCancel" @cancel="handlePickerCancel" @confirm="handlePickerConfirm3"></awesome-picker>
    <awesome-picker ref="picker4" :data="picker.data4" :textTitle="picker.textTitle4" :textConfirm="picker.textConfirm"
      :textCancel="picker.textCancel" @cancel="handlePickerCancel" @confirm="handlePickerConfirm4"></awesome-picker>
  </div>
</template>

<script>
import StatusBar from '../../components/StatusBar'
import { showToast, changeHistory, urlGet } from '../../utils/common'
import { getCityOpen, getSignUpInfo, updateBasic, checkInviteCode, submitInviteCode, getSwitch, checkStatus } from '../../utils/actions'
var signUpInfo = false
export default {
  name: 'SignUp',
  components: {
    StatusBar
  },
  data () {
    return {
      options: [],
      status: '',
      workCity: '工作地-城市',
      workCityId: '',
      workProvince: '工作地-省份',
      workType: '选择加盟司机类型',
      workTypeId: '',
      msgFrom: { value: '招募信息来源', index: '' },
      contactPhone: '',
      showConfirm: false,
      picker: {
        textTitle1: '请选择工作地省份',
        textTitle2: '请选择工作地城市',
        textTitle3: '请选择招募信息来源',
        textTitle4: '请选择加盟司机类型',
        textConfirm: '确定',
        textCancel: '取消',
        swipeTime: 1800,
        data1: [],
        data2: [],
        data3: [],
        data4: [{ id: 4, value: '轻享司机' }, { id: 1, value: '精选司机' }]
      },
      inviteCode: '',
      isShowWorkType: false,
      defaultInfo: {
        default: '95139',
        default_text: '司机加盟咨询热线：'
      }
    }
  },
  cityConform: '',
  async created () {
    console.log(this.$store)
    this.status = this.$route.params.status
    this.getOpenProvince()
    this.getMsgFrom()
    changeHistory()
    const query = urlGet()
    if (query.inviteCode) {
      this.inviteCode = query.inviteCode
    }
  },
  methods: {
    async getSwitchInfo () {
      let res = await getSwitch({
        city_id: this.workCityId,
        open_id: this.$store.state.openid
      })
      // res.work_type  0 精选 1 精选+轻享 -1 精选
      this.isShowWorkType = res.data.work_type === 1
    },
    provincePickerClick () {
      this.workCity = '工作地-城市'
      this.$refs.picker1.show()
      this.options = []
      var that = this
      setTimeout(() => {
        that.options = [{ num: 1 }]
      }, 100)
    },
    cityPickerClick () {
      if (this.workProvince === '工作地-省份') {
        showToast('请先选择省份')
        return
      }
      this.$refs.picker2[0].show()
    },
    fromPickerClick () {
      if (this.picker.data3.length > 0) {
        this.$refs.picker3.show()
      }
    },
    typePickerClick () {
      if (this.picker.data4.length > 0) {
        this.$refs.picker4.show()
      }
    },
    handlePickerCancel (e) {
    },
    getOpenProvince () {
      var that = this
      getCityOpen({ type: 2 }).then(function (res) {
        that.picker.data1 = []
        for (var i = 0; i < res.provincelist.length; i++) {
          var province = {
            value: res.provincelist[i].name,
            id: res.provincelist[i].id
          }
          that.picker.data1.push(province)
        }
      })
    },
    getOpenCity (id) {
      this.picker.data2 = []
      if (!id || id === 999) {
        return
      }
      var that = this
      getCityOpen({ type: 0, province_id: id }).then(function (res) {
        var list = []
        for (var i = 0; i < res.citylist.length; i++) {
          var city = {
            value: res.citylist[i].city_name,
            id: res.citylist[i].city_id
          }
          list.push(city)
        }
        that.picker.data2 = list
      })
    },
    getMsgFrom () {
      var parm = {
        open_id: this.$store.state.openid,
        id: this.$store.state.id
      }
      var that = this
      getSignUpInfo(parm).then(function (res) {
        if (!res || !res.data) return
        var list = res.data.src_list
        signUpInfo = true
        for (var key in list) {
          if (key < 0) {
            break
          }
          var obj = {
            value: list[key]
          }
          that.picker.data3.push(obj)
        }
        if (that.inviteCode) {
          that.setInviteInfo()
        }
      })
    },
    setInviteInfo () {
      this.picker.data3.some((item, index) => {
        if (item.value === '司机推荐') {
          this.msgFrom.value = item.value
          this.msgFrom.index = index
          return true
        }
      })
    },
    handlePickerConfirm1 (e) {
      this.workProvince = e[0].value
      var info = this.picker.data1[e[0].index]
      this.workTypeId = ''
      this.workType = '选择加盟司机类型'
      this.getOpenCity(info ? info.id : 999)
    },
    handlePickerConfirm2 (e) {
      this.workCity = e[0].value
      this.workCityId = this.picker.data2[e[0].index].id
      this.$store.commit('CITYID', this.workCityId)
      this.workTypeId = ''
      this.getSwitchInfo()
    },
    handlePickerConfirm3 (e) {
      this.msgFrom.value = e[0].value
      this.msgFrom.index = e[0].index
    },
    handlePickerConfirm4 (e) {
      console.log(e)
      this.workType = e[0].value
      this.workTypeId = this.picker.data4[e[0].index].id
      console.log(this.workTypeId)
      if (this.workTypeId) {
        getSwitch({
          open_id: this.$store.state.openid,
          city_id: this.workCityId,
          driver_work_type: this.isShowWorkType ? this.workTypeId : 1
        }).then((res) => {
          this.$store.commit('WORKTYPE', this.isShowWorkType ? this.workTypeId : 1)
          this.$store.commit('NEEDEXAM', res.data.exam)
        })
      }
    },
    async nextBtnClick (notCheckInviteCode) {
      var that = this
      if (that.workProvince === '工作地-省份') {
        showToast('请选择工作地省份')
        return
      }
      if (that.workCity === '工作地-城市') {
        showToast('请选择工作地城市')
        return
      }
      if (that.isShowWorkType) {
        if (!this.workTypeId) {
          showToast('请选择加盟司机类型')
          return
        }
      }
      if (that.msgFrom.value === '招募信息来源') {
        showToast('请选择招募信息来源')
        return
      }
      if (!(/^[1][3456789]\d{9}$/).test(that.contactPhone)) {
        showToast('请输入正确的紧急联系人手机号码')
        return
      }
      if (that.msgFrom.value === '司机推荐' && !notCheckInviteCode && this.workTypeId !== 4) {
        if (that.inviteCode.length === 0) {
          that.$confirm.show({
            message: '推荐码未填写，继续提交吗？',
            confirmText: '继续',
            cancelText: '取消',
            cancelCallback: function () {
              that.$confirm.close()
            },
            confirmCallback: function () {
              that.nextBtnClick(true)
              that.$confirm.close()
            }
          })
          return
        }
        const checkResult = await that.checkInviteCode()
        if (checkResult.code * 1 === 0) {
          that.cityConform = checkResult.data.cityConform
          if (!checkResult.data.invitePeople || checkResult.data.invitePeople === 'null') {
            that.$confirm.show({
              message: '推荐码无效，继续提交吗？',
              confirmText: '继续',
              cancelText: '取消',
              cancelCallback: function () {
                that.$confirm.close()
              },
              confirmCallback: function () {
                that.nextBtnClick(true)
                that.$confirm.close()
              }
            })
          } else {
            that.$confirm.show({
              message: `当前推荐码关联的司机为<span style='color:#00A0E8;'>${checkResult.data.invitePeople.name}</span>，\n继续提交吗？`,
              confirmText: '继续',
              cancelText: '取消',
              cancelCallback: function () {
                that.$confirm.close()
              },
              confirmCallback: function () {
                if (!checkResult.data.cityConform) {
                  that.$confirm.close()
                  that.$confirm.show({
                    message: `您选择的城市与推荐人绑定的城市\n【<span style='color: #00A0E8;'>${checkResult.data.cityName}</span>】不符，继续提交吗？`,
                    confirmText: '继续',
                    cancelText: '取消',
                    cancelCallback: function () {
                      that.$confirm.close()
                    },
                    confirmCallback: function () {
                      that.nextBtnClick(true)
                      that.$confirm.close()
                    }
                  })
                } else {
                  that.$confirm.close()
                  that.nextBtnClick(true)
                }
              }
            })
          }
          return
        }
      }

      if (this.msgFrom.value === '司机推荐') {
        await this.submitInviteCode()
      }

      var param = {
        open_id: this.$store.state.openid,
        id: this.$store.state.id,
        mobile: this.$store.state.phone,
        city_id: this.workCityId,
        src_value: this.msgFrom.value,
        sign_up_info: signUpInfo,
        src: this.msgFrom.index,
        method: 'driver.signup.update_basic',
        address: this.workProvince + this.workCity,
        contact_phone: this.contactPhone
      }
      param.driver_work_type = this.isShowWorkType ? this.workTypeId : 1
      updateBasic(param).then(async function (res) {
        if (res && res.code === 0) {
          var result = await getSwitch({
            open_id: that.$store.state.openid,
            city_id: that.workCityId,
            driver_work_type: that.isShowWorkType ? that.workTypeId : 1
          })
          let res = await checkStatus({
            open_id: that.$store.state.openid
          })
          if (res.data) {
            that.$store.commit('ID', res.data.id) // id
            that.$store.commit('CITYID', res.data.city_id) // cityId
            that.$store.commit('IDCAR', res.data.id_card) // cardId
            that.$store.commit('PHONE', res.data.mobile) // phone
            that.$store.commit('CNAME', res.data.company_name) // 路考分公司
            that.$store.commit('CPHONE', res.data.company_phone) // 分公司电话
            that.$store.commit('WORKTYPE', res.data.driver_work_type || '1') // 司机类型
          }
          if (result.data.exam) {
            that.$router.push({ name: 'recruitAnswer', params: { status: res.data.status } })
            return
          }
          that.$router.push({ name: 'cardIDUpLoad', params: { status: '5' } })
        }
      })
    },
    // 校验邀请码
    checkInviteCode () {
      return checkInviteCode({
        inviteCode: this.inviteCode,
        cityId: this.workCityId
      })
    },

    submitInviteCode () {
      return submitInviteCode({
        phone: this.$store.state.phone,
        boostOpenId: this.$store.state.openid,
        inviteCode: this.inviteCode,
        cityConform: this.cityConform
      })
    },
    inputBlurEvent () {
      window.scroll(0, 0)
    },
    cancelBtnAction () {
      this.showConfirm = false
    },
    sureBtnAction () {
      this.cancelBtnAction()
      this.nextBtnClick()
    },
    showConfirmBox () {
      if (this.workCity !== '工作地-城市' && this.workProvince !== '工作地-省份' && this.msgFrom.value !== '招募信息来源' && this.contactPhone.length === 11 && ((this.isShowWorkType && this.workTypeId) || !this.isShowWorkType)) {
        this.showConfirm = true
      } else {
        this.nextBtnClick()
      }
    }
  },
  computed: {
    complete () {
      if (this.workCity !== '工作地-城市' && this.workProvince !== '工作地-省份' && this.msgFrom.value !== '招募信息来源' && this.contactPhone.length === 11 && ((this.isShowWorkType && this.workTypeId) || !this.isShowWorkType)) {
        return ''
      }
      return 'opactiy'
    }
  }
}
</script>
<style lang="scss" scoped>
.row-bg {
  margin: 1.18rem 0.86rem 0.8rem;
  font-size: 0.28rem;
  box-sizing: border-box;

  .row {
    width: 100%;
    height: 0.98rem;
    border-bottom: 1px solid #e8e9eb;

    p {
      height: 0.98rem;
      width: 100%;
      line-height: 1.3rem;
      color: #97989b;
      background: url("../../assets/triangle_open@2x.png") right 70% no-repeat;
      background-size: 0.12rem 0.08rem;
    }

    input {
      border: none;
      height: 100%;
      width: 100%;
      box-sizing: border-box;
      padding-left: 0;
      padding-top: 0.3rem;
      background-color: transparent;
    }

    .txt-color {
      color: #19191a !important;
    }
  }

  .row1 {
    position: relative;

    p {
      display: inline-block;
    }

    .r-province {
      width: 40%;
    }

    .r-city {
      position: absolute;
      right: 0;
      width: 50%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.next-btn {
  width: 90%;
  margin-left: 5%;
  text-align: center;
  font-size: 0.3rem;
  height: 0.92rem;
  line-height: 0.92rem;
  color: #ffffff;
  border-radius: 0.04rem;
  background-image: linear-gradient(269deg, #3B414D 0%, #262A32 100%);
}

.opactiy {
  opacity: 0.3;
}

.detail {
  margin-top: 0.2rem;
  width: 100%;
  text-align: center;
  font-size: 0.24rem;
  color: #97989b;
}

.introduce-container {
  width: 90%;
  margin: .6rem auto 1rem;

  .introduce-title {
    width: max-content;
    position: relative;
    font-size: .28rem;
    font-weight: bold;
    color: #19191A;
    line-height: .4rem;

    .text {
      position: relative;
      z-index: 99;
    }

    .bgc {
      width: 100%;
      height: .26rem;
      position: absolute;
      bottom: 0;
      left: 0;
      background-color: #D4E9FF;
    }
  }

  .introduce-desc {
    font-size: .24rem;
    color: #19191A;
    line-height: .34rem;
    margin: .3rem 0;
  }

}

.confirm {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);

  .c-bg {
    position: absolute;
    top: 3rem;
    transform: translateX(-50%);
    width: 6.5rem;
    height: 4rem;
    left: 50%;
    background: #FFFFFF;
    box-shadow: 0 0 0.1rem 0 rgba(0, 0, 0, 0.20);
    border-radius: 2px;

    .c-title {
      text-align: center;
      font-size: 0.32rem;
      color: #19191A;

      p {
        padding-top: 0.54rem;
      }
    }

    .c-content {
      font-size: 0.28rem;
      color: #19191A;
      margin-left: 1.12rem;
      margin-top: 0.4rem;
    }

    .c-bottom {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      font-size: 0.32rem;
      height: 1rem;
      box-sizing: border-box;
      text-align: center;
      border-top: 1px solid #E8E9EB;
      display: flex;

      p {
        flex: 1;
        height: 100%;
        line-height: 1rem;
      }

      .c-cancel {
        color: #646566;
      }

      .c-sure {
        border-left: 1px solid #E8E9EB;
      }
    }
  }
}

.tips {
  width: 100%;
  height: .8rem;
  text-align: center;
  font-size: .24rem;
  background-color: #ffffff;
  font-weight: 400;
  color: #19191A;
  line-height: .8rem;
  position: fixed;
  bottom: 0rem;

  span {
    color: #2A2AFF;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/sign-up/index.vue